import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface StatsYearSelectorProps {
  currentYear: number;
  onYearSelect: (year: number) => void;
}

export const StatsYearSelector: React.FC<StatsYearSelectorProps> = ({
  currentYear,
  onYearSelect
}) => {
  const { t, i18n } = useTranslation();

  const today = new Date();
  const currentYearNow = today.getFullYear();
  
  // Генерируем список лет (от 2025 до 2027)
  const years = [];
  for (let year = 2025; year <= 2027; year++) {
    years.push(year);
  }

  // Группируем годы в сетку 3x4
  const yearGrid = [];
  for (let i = 0; i < years.length; i += 3) {
    const row = years.slice(i, i + 3);
    yearGrid.push(
      <div key={i} className="grid grid-cols-3 gap-2">
        {row.map((year) => (
          <button
            key={year}
            onClick={() => onYearSelect(year)}
            className={`
              p-3 rounded-lg border border-border transition-colors focus:outline-none focus:ring-0
              ${year === currentYearNow && year >= 2025
                ? 'bg-primary text-primary-foreground font-bold border-primary' // Текущий год
                : year === currentYear
                  ? 'bg-hover text-white border-primary' // Выбранный год
                  : 'bg-header text-white' // Обычный год
              }
            `}
          >
            {year === currentYearNow && year >= 2025 ? `[${year}]` : year}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Сетка годов */}
      <div className="space-y-2">
        {yearGrid}
      </div>
    </div>
  );
}; 